import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
export var ChevronDirection;
(function (ChevronDirection) {
    ChevronDirection[ChevronDirection["UP"] = 0] = "UP";
    ChevronDirection[ChevronDirection["DOWN"] = 180] = "DOWN";
    ChevronDirection[ChevronDirection["LEFT"] = -90] = "LEFT";
    ChevronDirection[ChevronDirection["RIGHT"] = 90] = "RIGHT";
})(ChevronDirection || (ChevronDirection = {}));
const Chevron = (props) => {
    const { IconLight500 } = useTokens();
    const svgStyle = {
        transform: `rotate(${props.direction}deg)`,
    };
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", style: svgStyle, fill: props.fill ?? IconLight500, xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement("path", { opacity: props.disabled ? '50%' : '100%', d: "M16.59 16L12 11.41L7.41 16L6 14.58L12 8.58L18 14.58L16.59 16Z" })));
};
export default Chevron;
